import { render, staticRenderFns } from "./CommunityNotificationItem.vue?vue&type=template&id=75fcf3ef&scoped=true&"
import script from "./CommunityNotificationItem.vue?vue&type=script&lang=js&"
export * from "./CommunityNotificationItem.vue?vue&type=script&lang=js&"
import style0 from "./CommunityNotificationItem.vue?vue&type=style&index=0&id=75fcf3ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fcf3ef",
  null
  
)

export default component.exports